const CircleShape = ({ shapeId, elementProperties = {} }) => {
  const {
    isTransparent = false,
    strokeWidth = 1,
    backgroundColor = "#ffffff",
    borderColor = "#000000",
    strokeUnit = "",
    opacity = 100,
  } = elementProperties;
  
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      id={shapeId}
      style={{ opacity: opacity / 100 }}
    >
      <circle
        id={shapeId}
        cx="50"
        cy="50"
        r="48"
        fill={isTransparent ? "none" : backgroundColor}
        stroke={borderColor}
        strokeWidth={`${strokeWidth}${strokeUnit}`}
      />
    </svg>
  );
};

export default CircleShape;